import { render, staticRenderFns } from "./ShipmentList.vue?vue&type=template&id=184d599c&"
import script from "./ShipmentList.vue?vue&type=script&lang=ts&"
export * from "./ShipmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports